import React from 'react';
import styles from './SignFormConfirmation.module.scss';
import { FaCheck, FaCreditCard, FaEnvelopeOpenText } from 'react-icons/fa';
import { formatTranslationNode } from '../../utils/utils';
import { useTranslation } from 'react-i18next';
import PageDialog from '../../utils/PageDialog';

const SignFormConfirmation = () => {
  const { t } = useTranslation();
  return (
    <PageDialog title={t('register_label')} maxWidth={760}>
      <div className={styles.wrap}>
        <div className={styles.badge}>
          <FaCheck />
        </div>
        <h3 className={styles.title}>
          {formatTranslationNode('register_thx')}
        </h3>
        <p className={styles.notice}>{t('register_thx_body1')}</p>
        <div className={styles.next}>
          <h4>{t('register_thx_body2')}</h4>
          <div className={styles.step}>
            <span className={styles.stepIcon}>
              <FaEnvelopeOpenText />
            </span>
            <p>{t('register_thx_body3')}</p>
          </div>
          <div className={styles.step}>
            <span className={styles.stepIcon}>
              <FaCreditCard />
            </span>
            <p>{t('register_thx_body4')}</p>
          </div>
        </div>
        <p className={styles.signoff}>
          {formatTranslationNode('register_thx_signoff')}
        </p>
      </div>
    </PageDialog>
  );
};

export default SignFormConfirmation;
